import { useEffect } from 'react';

// Adds a class to <body> while the component is mounted (template CSS scopes
// the catalog styles under body.catalog-page).
export function useBodyClass(className: string) {
  useEffect(() => {
    document.body.classList.add(className);
    return () => {
      document.body.classList.remove(className);
    };
  }, [className]);
}
